var openStateString   = 'open';
var closedStateString = 'closed';
var storageKey        = 'lp_contentTreeState';

var getDefaultState = function() {
  return closedStateString;
};

var getPersistedState = function() {
  return (window.localStorage && window.localStorage.getItem(storageKey));
};

var getState = function() {
  return getPersistedState() || getDefaultState();
};

var saveVisibility = function(state) {
  if (window.localStorage) {
    window.localStorage.setItem(storageKey, state);
  }
};

window.lp.editor.TreeToggler = function(editor) {
  this.editor = editor;
};

window.lp.editor.TreeToggler.prototype = {
  isOpen: function() {
    return getState() === openStateString;
  },

  open: function() {
    saveVisibility(openStateString);
    if (this.editor && this.editor.contentPanel && this.editor.contentPanel.tree) {
      this.editor.contentPanel.tree.updateTree();
    }
  },

  close: function() {
    saveVisibility(closedStateString);
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/tree_toggler.js
// module id = 999
// module chunks = 0